import React from 'react'
import injectSheet from 'react-jss'
import TabLink from './tab-link/tab-link'

const styles = ({ BREAKPOINTS, COLORS, FONT_SIZES }) => ({
  container: {
    ...FONT_SIZES.BODY_LARGE.STYLE,
    display: 'flex',
    borderBottom: '1px solid #ececec',
    '& > *': {
      margin: '0 0 -0.25em 32px',
      '&:first-child': {
        marginLeft: '0'
      }
    }
  },
  hideMobile: {
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      display: 'none'
    }
  },
  shared: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  sharedCounter: {
    opacity: '0',
    animation: '0.3s fadeIn ease-out forwards',
    fontSize: '12px',
    lineHeight: '1.2',
    display: 'inline-flex',
    background: COLORS.RED.FADED,
    color: '#fff',
    margin: '2px 0 0 6px',
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center',
    width: '22px',
    height: '22px',
    borderRadius: '22px'
  },
  '@keyframes fadeIn': {
    from: { opacity: '0' },
    to: { opacity: '1' }
  }
})

const TabNav = ({ classes, activeTab, changeActiveTab, sharedCounter }) => (
  <div className={classes.container}>
    <TabLink to="/">My lessons</TabLink>
    <div className={classes.shared}>
      <TabLink to="/shared">
        Shared<span className={classes.hideMobile}> with me</span>
      </TabLink>
      {!!sharedCounter && (
        <span className={classes.sharedCounter}>{sharedCounter}</span>
      )}
    </div>
  </div>
)

export default injectSheet(styles)(TabNav)
